import axios from "../config/axiosAuth";
import CommonHeaders from "./commonHeaders";

export const getUserById = (user_id) => {
  return axios.get(
    `/user-mgmt-api/v1/visa-lancer/getUser/${user_id}`,
    CommonHeaders()
  );
};

export const updateUserProfileDetails = (user_id, updateObject) => {
  return axios.patch(
    `/user-mgmt-api/v1/visa-lancer/userUpdate/${user_id}`,
    updateObject,
    CommonHeaders()
  );
};

export const ShareVisaLancerLink = (user_id, session_id) => {
  return axios.post(
    "ancillary-products-api/v1/visa-lancer/shareLinkViaVisaLancer",
    {
      user_id,
      session_id,
    },
    CommonHeaders()
  );
};

export const getVisaLancerDashboard = () => {
  const user_id = localStorage.getItem("userId");
  return axios.post(
    `/ancillary-products-api/v1/visa-lancer/getVisaLancerUserDashboard`,
    { user_id },
    CommonHeaders()
  );
};
export const getVisaLancerRewardsSummary = () => {
  // const user_id = "68b05909081010e3ab80832d";
  const user_id = localStorage.getItem("userId");
  return axios.post(
    `/ancillary-products-api/v1/visa-lancer/getVisaLancerRewardsSummary`,
    { user_id },
    CommonHeaders()
  );
};

export const updateProfilePhoto = (formData) => {
  return axios.post(
    "/user-mgmt-api/v1/visa-lancer/uploadProfilePhoto",
    formData,
    CommonHeaders()
  );
};
